import { Paper, Box, Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import FavoriteIcon from '@mui/icons-material/Favorite';

interface BottomNavigationProps {
  activeTab: number;
  onTabChange: (tab: number) => void;
}

const tabs = [
  { label: 'Bands', icon: GroupsIcon },
  { label: 'Queue', icon: QueueMusicIcon },
  { label: 'Favorites', icon: FavoriteIcon },
];

const BottomNavigation = ({ activeTab, onTabChange }: BottomNavigationProps) => {
  return (
    <Paper
      elevation={4}
      sx={{
        position: 'fixed',
        bottom: 72, // Space for PlayerBar
        left: 0,
        right: 0,
        zIndex: 1100,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          height: 56,
        }}
      >
        {tabs.map((tab, index) => {
          const Icon = tab.icon;
          const isActive = activeTab === index;
          
          return (
            <Box
              key={tab.label}
              onClick={() => onTabChange(index)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                height: '100%',
                cursor: 'pointer',
                bgcolor: isActive ? 'rgba(66, 165, 245, 0.12)' : 'transparent',
                transition: 'background-color 0.2s',
                '&:hover': {
                  bgcolor: isActive ? 'rgba(66, 165, 245, 0.16)' : 'action.hover',
                },
              }}
            >
              <Icon
                sx={{
                  color: isActive ? 'primary.main' : 'text.secondary',
                  fontSize: 24,
                  mb: 0.5,
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: isActive ? 'primary.main' : 'text.secondary',
                  fontWeight: isActive ? 600 : 400,
                  fontSize: '0.75rem',
                }}
              >
                {tab.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
};

export default BottomNavigation;
